import { Directive, ElementRef, HostListener } from "@angular/core";

@Directive({
  selector: "[appAlphanumericOnly]",
})
export class AlphanumericOnlyDirective {
  private regex: RegExp = new RegExp(/^[a-zA-Z0-9]*$/);
  private specialKeys: Array<string> = [
    "Backspace",
    "Tab",
    "End",
    "Home",
    "ArrowLeft",
    "ArrowRight",
    "Delete",
    "Control",
    "a",
    "c",
    "v",
  ];

  constructor(private el: ElementRef) {}

  @HostListener("keydown", ["$event"])
  onKeyDown(event: KeyboardEvent) {
    if (
      this.specialKeys.indexOf(event.key) !== -1 ||
      (event.ctrlKey === true && ["a", "c", "v"].includes(event.key))
    ) {
      return;
    }

    const current: string = this.el.nativeElement.value;
    const position = this.el.nativeElement.selectionStart;
    const next: string = [
      current.slice(0, position),
      event.key,
      current.slice(position),
    ].join("");

    if (next && !String(event.key).match(this.regex)) {
      event.preventDefault();
    }
  }

  @HostListener("paste", ["$event"])
  onPaste(event: ClipboardEvent) {
    const clipboardData = event.clipboardData || (window as any).clipboardData;
    const pastedText = clipboardData.getData("text");
    if (!this.regex.test(pastedText)) {
      event.preventDefault();
    }
  }
}
